import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { SearchableSelect } from '../ui/searchable-select';
import { UserPlus } from '@phosphor-icons/react';

export const AgencyFileAssignDialog = ({
  assignDialog, setAssignDialog, staffList,
  assignStaffId, setAssignStaffId,
  assignInstruction, setAssignInstruction,
  handleAssign,
}) => (
  <Dialog open={assignDialog.open} onOpenChange={(o) => { if (!o) setAssignDialog({ open: false, file: null }); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Assign: {assignDialog.file?.agency_name}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-3 text-sm">
          <p>Date: <strong>{assignDialog.file?.entry_date}</strong></p>
          <p>Entries: <strong>{assignDialog.file?.entry_count}</strong></p>
          <p>Oil Company: <strong>{assignDialog.file?.oil_company}</strong></p>
        </div>
        <div>
          <Label>Select Staff *</Label>
          <SearchableSelect
            options={staffList.map(s => ({ value: s.id, label: s.name, sublabel: s.email }))}
            value={assignStaffId}
            onValueChange={setAssignStaffId}
            placeholder="Staff choose karo..."
            data-testid="assign-staff-select"
          />
        </div>
        <div>
          <Label>Instruction (Optional)</Label>
          <Input value={assignInstruction} onChange={e => setAssignInstruction(e.target.value)}
            placeholder="e.g. Aaj complete karna hai" data-testid="assign-instruction-input" />
        </div>
        <Button onClick={handleAssign} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="confirm-assign-btn">
          <UserPlus size={16} className="mr-2" /> Assign to Staff
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
